import React, { useState } from 'react';
import { Alert, Card } from 'react-bootstrap';
import { toast, ToastContainer } from 'react-toastify';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { Role } from '../../../common/spdCore/authorization/roles';
import { Filter, FilterReportData } from '../RegistersView/Filter';
import { Waiting } from '../../../common/components/Waiting/Waiting';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const ReportSalesInvoicesView: React.FC = () => {
  const spd = useSpdCore();
  const [waiting, setWaiting] = useState<boolean>(false);
  const [alert, setAlert] = useState<string>('');

  const onSearch = async (filter: FilterReportData) => {
    setAlert('Pobieranie danych, proszę czekać...');
    setWaiting(true);

    const currentDate = new Date().toISOString().split('T')[0];
    try {
      await spd.reportsExcel.reportSalesInvoices(
        `zestawienie_faktur_sprzedazy_${currentDate}.xlsx`,
        filter,
      );
      setWaiting(false);
    } catch (response) {
      const err = await responseErrors(response as ResponseError);
      toast.error(err?.[0]);
      setWaiting(false);
    }
  };

  return (
    <>
      <ToastContainer />
      <Card id="sales-invoices-report">
        <Card.Body>
          <Filter
            onSearch={onSearch}
            headerName={'Zestawienie faktur sprzedaży'}
            roles={[Role.Admin, Role.Finance]}
            withUser={false}
            withDate={true}
            withHealthcareFacility={false}
            withCompany={true}
            dateFromText={'Data wystawienia od'}
            dateToText={'Data wystawienia do'}
            canClean={true}
            emptyOnStart={false}
            withLinkedPayments={true}
            withOnlyUnpaid={true}
          />
        </Card.Body>
      </Card>
      {waiting && (
        <>
          <Alert variant="warning">{alert}</Alert>
          <Waiting />
        </>
      )}
    </>
  );
};
